<template>
  <el-dialog :visible=" show " title="历史复拍" width="770px" append-to-body :close-on-click-modal="false" @close="closeDialog">
    <el-form ref="vForm" label-width="100px" :model="vForm" size="medium">

      <el-form-item label="拍摄日期" prop="remarkTime" :rules="{required:true,message:'拍摄日期必填'}">
        <el-date-picker v-model="vForm.remarkTime" type="date" placeholder="选择日期" style="width:100%;" value-format="yyyy-MM-dd"></el-date-picker>
      </el-form-item>
      <el-form-item label="全景图片">
        <div class="vr-list">
          <div class="item">
            <div class="upload-btn" @click="chooseImages()">
              <i class="icon el-icon-plus"></i>
              <div class="txt">批量上传</div>
            </div>
          </div>
          <div class="item" v-for="item in lists" :key="item.id">
            <div v-if="!item.fileData" class="upload-btn" @click="chooseImage(item)">
              <i class="icon el-icon-plus"></i>
              <div class="txt">{{ item.name }}</div>
            </div>
            <div v-if="item.fileData && item.fileData.status == 1" class="waiting">
              <div class="waiting-txt">等在上传...</div>
              <div class="name v-ellipsis v-mt-10 v-font-12">{{ item.name }}</div>
            </div>
            <div v-if="item.fileData && item.fileData.status == 2" class="progress">
              <el-progress class="progress-bar" :text-inside="true" :stroke-width="24" :percentage="item.fileData.percent" status="success"></el-progress>
              <div class="name v-ellipsis v-mt-10 v-font-12">{{ item.name }}</div>
            </div>
            <template v-if="item.fileData && item.fileData.status == 3">
              <img class="preview" :src="`${item.fileData.preview}?imageView2/1/w/200/h/125`" />
              <div class="preview-footer">
                <div class="name v-ellipsis v-font-12">{{ item.name }}</div>
                <i class="el-icon-delete" @click="item.fileData = null"></i>
              </div>
            </template>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog">关闭</el-button>
      <el-button type="primary" :loading="doSubmitLoading" size="small" @click="doSubmit">确 定</el-button>
    </div>
    <input ref="files" type="file" multiple="multiple" hidden accept="*/image" /> <input ref="file" type="file" hidden accept="*/image" />
  </el-dialog>
</template>

<script>

	export default {
		props: {
			show: {
				type: Boolean,
				default: false
			},
			row: {
				type: Object,
				default: null
			}
		},

		data() {
			return {
				doSubmitLoading: false,
				loading: false,
				lists: [],
				vForm: {
					remarkTime: '',
					worksId: this.row.id,
					materialData: []

				},
				isShowMap: false,
				isShowMapDialog: false
			}
		},


		created() {
			this.getLastList();
		},

		methods: {

			async getLastList() {
				this.loading = true;
				try {
					let res = await this.api.works.getLastList({worksId: this.row.id});
					this.lists = res.data;
					console.log(this.lists)
				} catch (e) {
					console.error(e)
				}
				this.loading = false;
			},

			closeDialog() {
				this.$emit('update:show', false);
			},

			chooseImages() {
				let $files = this.$refs.files;
				$files.click();
				$files.onchange = async (e) => {
					let files = e.target.files;
					files = Array.from(files);
					files.length = Math.min(this.lists.length,files.length);
					files.forEach((file, index) => {
						let row = this.lists[index];
						this.$set(row, 'fileData', {file: file, status: 1, percent: 0, name: file.name});
						this.doUpload(row);
					})
					$files.value = '';
				}
			},

			chooseImage(row) {
				let $file = this.$refs.file;
				$file.click();
				$file.onchange = async (e) => {
					let file = e.target.files[0];
					this.$set(row, 'fileData', {file, status: 1, percent: 0, name: file.name});
					this.doUpload(row);
					$file.value = '';
				};
			},


			async doUpload(row) {
				try {
					row.fileData.status = 2;
					let res = await this.utils.upload.uploadFile(row.fileData.file, {
						progress: (e) => {
							row.fileData.percent = parseInt(e.total.percent);
						}
					});
					row.fileData.status = 3;
					row.fileData.preview = res.preview;
					row.fileData.key = res.key;
				} catch (e) {
					console.error(e);
				}
			},

			//提交作品
			async doSubmit() {
				this.doSubmitLoading = true;
				try {
					await this.$refs.vForm.validate();
					let materialData = this.lists.filter(item => item.fileData).map(item => ({name: item.name, image: item.fileData.key, pid: item.pid, tid: item.tid}));
					if (materialData.find(item => !item.image) || materialData.length < this.lists.length) {
						this.$message.error('请补全所有全景图片');
						return
					}
					await this.api.material.addRetakeMaterial(Object.assign(this.vForm, {materialData}));
					this.$message.success('提交成功');
					this.closeDialog();
				} catch (e) {
					console.error(e)
				}
				this.doSubmitLoading = false;
			}
		}
	}
</script>

<style scoped>
  .vr-list {
    display: flex;
    flex-wrap: wrap;
  }

  .vr-list .item {
    width: 200px;
    height: 125px;
    border-radius: 4px;
    overflow: hidden;
    margin: 0 10px 10px 0;
    position: relative;
  }

  .vr-list .upload-btn {
    border: 1px dashed #9a9a9a;
    cursor: pointer;
    color: #9a9a9a;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }

  .vr-list .upload-btn .icon {
    font-size: 22px;
  }

  .vr-list .upload-btn .txt {
    font-size: 12px;
  }


  .progress,
  .waiting {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 125px;
    border: 1px dashed #9a9a9a;
    border-radius: 4px;
    color: #999;
    box-sizing: border-box;
  }

  .progress-bar {
    width: 120px;
    margin: 0 auto;
  }

  .vr-list .preview {
    border: 1px dashed #f1f1f1;
    display: block;
    border-radius: 4px;
    height: 100%;
    width: 100%;
  }

  .vr-list .preview-footer {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 26px;
    line-height: 26px;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 12px;
    display: flex;
    align-items: center;
    padding-left: 10px;
    padding-right: 5px;
    box-sizing: border-box;
  }

  .vr-list .preview-footer .name {
    flex: 1;
  }

  .vr-list .preview-footer i {
    width: 26px;
    height: 26px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>

